<template>
    <div id="teacher-day">
        <div style="position:fixed; bottom:104px; right: 34px; z-index: 9999;" >
            <el-badge :value="receiveMessages?.length ?? 0" class="item bounce-animation" >
                <img src="/media/20-10.jpg"  alt="logo-zalo"  @click="outerVisible = true" style="width: 40px; height: 40px">
            </el-badge>
        </div>
        <el-dialog
            class="responsive teacher-day"
            :visible.sync="outerVisible"
            @close="clearForm"
        >
            <div class="row min-height max-height-reset" v-if="!creatingGift">
                <div class="col-md-5">
                    <el-button type="primary" style="margin-bottom: 18px;border-color: #463379; background:#463379;" size="mini" @click="creatingGift = true">Tạo lời chúc </el-button>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="Đã nhận" name="Đã nhận" class="message-list">
                            <div v-for="receive in receiveMessages" :key="receive.id" @click="viewMessage(receive)" >
                                <ItemUserSend :message="receive" :type="1" :message-selected-id="messageSelected?.id"/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="Đã gửi" name="Đã gửi" class="message-list">
                            <div v-for="receive in sentMessages" :key="receive.id" @click="viewMessage(receive)">
                                <ItemUserSend :message="receive" :type="2" :message-selected-id="messageSelected?.id"/>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="col-md-7">
                    <h3 class="text-center " style="margin-bottom: 21px; color: #463379; word-break: break-word">Lời chúc của bạn</h3>
                    <div v-if="messageSelected" >
                        <MessageView :message="messageSelected?.message" :sender="`${messageSelected?.sender?.name} from Edutalk with love ! ❤️❤️❤️`"/>
                    </div>
                    <div v-else class="h-100 d-flex align-items-center justify-content-center" >
                        Bạn chưa có lời chúc nào
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-5">
                    <el-button  icon="el-icon-arrow-left" style="margin-bottom: 18px" size="mini" @click="handleViewMessage">Lời chúc của bạn</el-button>
                    <div class="">
                        <el-autocomplete
                            class="inline-input w-100 mb-3"
                            v-model="form.name"
                            :fetch-suggestions="querySearch"
                            placeholder="Bạn muốn gửi đến ai?"
                            :trigger-on-focus="false"
                            @select="handleSelect"
                        />
                        <div>
                            <el-input
                                type="textarea"
                                class="w-100 mb-3"
                                :rows="10"
                                placeholder="Nhập lời chúc đến người thầy của bạn"
                                v-model="form.content">
                            </el-input>
                        </div>
                        <el-button :disabled="disabledSubmit" type="primary" class="w-100" style="margin-bottom: 18px ; border-color: #463379; background:#463379;" size="medium" @click="sendMessage">Gửi lời chúc </el-button>
                    </div>
                </div>
                <div class="col-md-7">
                    <h3 class="text-center" style="margin-bottom: 21px; color: #463379; word-break: break-word">Anh em hãy gửi những lời cảm ơn, lời chúc chân thành nhất tới người cấp trên, những người thầy mà bạn trân trọng nhất tại Edutalk!</h3>
                    <div class="container-message">
                        <MessageView :message="form.content" :sender="`${currentUser?.name} from Edutalk with love ! ❤️❤️❤️`"/>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ItemUserSend from "./ItemUserSend.vue";
import {
    FIND_USERS,
    GET_MESSENGERS,
    SENT_MESSENGER
} from "../../core/services/store/teacher-holiday/teacherHoliday.module";
import {mapGetters} from "vuex";
import MessageView from "./MessageView.vue";
import moment from "moment-timezone";

export default {
    components: {
        MessageView,
        ItemUserSend
    },
    data() {
        return {
            outerVisible: null,
            innerVisible: false,
            creatingGift: false,
            messageSelected: null,
            form: {
                name: '',
                content: '',
            },
            receiveMessages: [],
            sentMessages: [],
            isMobile: window.innerWidth < 768,
            isTablet: window.innerWidth <= 820,
            isDesktop: window.innerWidth > 1440,
            receiverId: null,
            activeName: 'Đã nhận',
            messages: [],
            disabledSubmit: false
        };
    },
    computed: {
        ...mapGetters(['currentUser'])
    },
    methods: {
        async querySearch(query, cb) {
            if (!query) {
                cb([]);
                return;
            }

            try {
                let suggestions
                await this.$store.dispatch(FIND_USERS, {keyword: query}).then(res => {
                    suggestions = res.data.map(user => ({
                        value: user.name,
                        id: user.id,
                    }));
                })
                cb(suggestions);
            } catch (e) {
                console.error("Error fetching users:", e);
                cb([]);
            }
        },
        sendMessage() {
            this.disabledSubmit = true
            this.creatingGift = true;
            const payload = {
                receiver_id: this.receiverId,
                message : this.form.content,
            }
            this.$store.dispatch(SENT_MESSENGER, payload).then(res => {
                if (!res.error) {
                    this.$message.success(res.message)
                    this.clearForm()
                    this.getMessages()
                }
            }).catch(e => {
                console.log(e)
            }).finally(() => this.disabledSubmit = false)
        },
        clearForm() {
            this.form.name = ''
            this.form.content = ''
            localStorage.removeItem('teacher-day')
        },
        handleSelect(item) {
            this.form.name = item.value;
            this.receiverId = item.id
        },
        viewMessage(message) {
            if (message) {
                this.messageSelected = message
            }
        },
        handleViewMessage() {
            this.creatingGift = false
            if (this.messages && this.messages.length > 0) {
                this.receiveMessages = this.messages.filter(item => +item?.receiver_id === this.currentUser.id) ?? []
                this.sentMessages = this.messages.filter(item => +item?.receiver_id !== this.currentUser.id) ?? []
            } else {
                this.getMessages()
                return
            }
            this.setMessageByActiveTab()
        },
        handleClick(tab, event) {
            this.setMessageByActiveTab()
        },
        setMessageByActiveTab() {
            if (this.activeName === 'Đã nhận') {
                this.messageSelected = this.receiveMessages[0] ?? null
            } else {
                this.messageSelected = this.sentMessages[0] ?? null
            }
        },
        formatDate(date) {
            if (!date) return null
            return moment(date).tz("Asia/Ho_Chi_Minh").format("YYYY")
        },
        getMessages() {
            this.$store.dispatch(GET_MESSENGERS).then(res => {
                if (!res.error) {
                    const currentYear = moment().tz("Asia/Ho_Chi_Minh").format("YYYY");
                    this.messages = res.data?.filter(item => currentYear === this.formatDate(item.created_at)) ?? []
                    this.sentMessages = res.data.filter(item => +item?.receiver_id !== this.currentUser.id && currentYear === this.formatDate(item.created_at)) ?? []
                    this.receiveMessages = res.data.filter(item => +item?.receiver_id === this.currentUser.id && currentYear === this.formatDate(item.created_at)) ?? []
                    this.creatingGift = res.data.filter(item => +item?.receiver_id === this.currentUser.id)?.length === 0
                    this.setMessageByActiveTab()
                }
            })
        },
        getValueTeacherDay() {
            const defaultDates = ['19/11', '20/11', '21/11'];
            const today = moment().tz("Asia/Ho_Chi_Minh").format("DD/MM");
            const isTrusty = defaultDates.includes(today);
            setTimeout(() => {
                this.outerVisible = localStorage.getItem('teacher-day') === '1' && isTrusty
            }, 0)
        }
    },
    mounted() {
        localStorage.setItem('teacher-day', '1')
        this.getMessages()
        this.getValueTeacherDay()
    }
}
</script>

<style>
    #teacher-day .el-textarea__inner {
        word-break: break-word !important;
    }
    .min-height {
        min-height: 500px;
    }
    .container-message {
        position: relative;
        height: 500px;
    }
    #teacher-day .message-list {
        height: 400px;
        overflow-y: auto;
    }
</style>
